export const en = {
  SignatureInfo: {
    CheckHash: "Check hash",
    SignatureBlock: "Signature block",
    Issuer: "Issued by",
    Subject: "Subject",
    SerialNumber: "Serial number",
    Version: "Version",
    NotValidBefore: "Starting validity date",
    NotValidAfter: "Expiration date",
    Algorithm: "Algorithm",
    PublicKey: "Public Key",
    PublicKeyParameters: "Public key parameters",
    Field: "Field",
    Value: "Value",
    General: "General",
    Details: "Details",
    CertificateInformation: "Certificate Information",
    IssuedTo: "Issued to",
    NotValidBeforeShort: "Valid from",
    NotValidAfterShort: "to",
    Verified: "Verified",
    NotVerified: "Not Verified",
    Close: "Close",
    CertificatePurposes: {
      Header: "This certificate is used for the following purposes:",
      emailProtection: "Protect e-mail messages",
      documentSign: "Document Signing",
      clientAuth: "Prove your identity to a remote computer",
      smartCardLogon: "Allow logging on to devices with a smart card",
      nonRepudiation: "Non repudiation",
      digitalSignature: "Digital Signature",
      documentEnc: "Document Encryption",
      serverAuth: "Prove your server identity",
      codeSigning: "Code signing",
      timestamping: "Timestamping",
      keyEncipherment: "Key encipherment",
      any: "Any other purpose"
    }
  }
}
